import api from './api';

const ngoService = {
  // Get all active NGOs
  getActiveNGOs: async () => {
    const response = await api.get('/partners/ngos/');
    // Handle paginated response - return results array
    return response.data.results || response.data;
  },

  // Get NGO details
  getNGODetail: async (id) => {
    const response = await api.get(`/partners/ngos/${id}/`);
    return response.data;
  },
};

export default ngoService;
